export const teamMembers = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john@company.com',
    role: 'Admin',
    status: 'Active',
    avatar: 'JD',
    lastActive: '2 hours ago',
    joinedDate: 'Jan 12, 2023'
  },
  {
    id: 2,
    name: 'Alex Lee',
    email: 'alex@company.com',
    role: 'Manager',
    status: 'Active',
    avatar: 'AL',
    lastActive: '5 hours ago',
    joinedDate: 'Mar 05, 2023'
  },
  {
    id: 3,
    name: 'Sarah Chen',
    email: 'sarah@partner.com',
    role: 'Contributor',
    status: 'Pending',
    avatar: 'SC',
    lastActive: 'Never',
    joinedDate: 'Oct 20, 2023'
  },
  {
    id: 4,
    name: 'Mike Ross',
    email: 'mike@consultant.com',
    role: 'Viewer',
    status: 'Active',
    avatar: 'MR',
    lastActive: '1 day ago',
    joinedDate: 'Dec 15, 2023'
  }
];

export const roleDefinitions = {
  Admin: {
    label: 'Admin',
    description: 'Full access to all assessments, billing, and team management.',
    color: 'text-purple-700 bg-purple-50 border-purple-100'
  },
  Manager: {
    label: 'Manager',
    description: 'Can create assessments, view all reports, and invite non-admin members.',
    color: 'text-blue-700 bg-blue-50 border-blue-100'
  },
  Contributor: {
    label: 'Contributor',
    description: 'Can view assigned assessments and contribute to action items.',
    color: 'text-green-700 bg-green-50 border-green-100'
  },
  Viewer: {
    label: 'Viewer',
    description: 'Read-only access to final reports and dashboards.',
    color: 'text-gray-700 bg-gray-50 border-gray-100'
  }
};